import React from "react";
import PropTypes from "prop-types";
import getStoriesByCollection from "../../../utils";
import HorizontalStoryCard from "../../molecules/horizontal-story-card";
import { CollectionName } from "../../atoms/collection-name";
import OnecolFourStories from "../../molecules/one-col-four-stories";
import SubscribeOnlyColumn from "../../molecules/subscribe-only-column"

import "./three-collections-with-poll.m.css";

const ThreeCollectionsWithPoll = ({ collection = {} }) => {
  if (collection.items.length <= 0) {
    return null;
  }
  const collections = collection.items.filter(collection => collection.type === "collection");
  const firstCollectionStories = getStoriesByCollection(collections[0]) || [];
  const secondCollectionStories = getStoriesByCollection(collections[1]) || [];
  const thirdCollectionStories = getStoriesByCollection(collections[2]) || [];
  return (
    <div className="full-width-with-padding" styleName="wrapper">
      <div styleName="grid-container" className="container">
        {firstCollectionStories.length > 0 && (
          <div styleName="col">
            <CollectionName collection={collections[0]} />
            <SubscribeOnlyColumn stories={firstCollectionStories} />
          </div>
        )}
        {secondCollectionStories.length > 0 && (
          <div styleName="col">
            <CollectionName collection={collections[1]} />
            <OnecolFourStories stories={secondCollectionStories} />
          </div>
            )}

        {thirdCollectionStories.length > 0 && (
          <div styleName="col">
          <CollectionName collection={collections[2]} />
          <OnecolFourStories stories={thirdCollectionStories} />
        </div>
        )}
      </div>
    </div>
  );
};

ThreeCollectionsWithPoll.propTypes = {
  collection: PropTypes.object
};

export default ThreeCollectionsWithPoll;

ThreeCollectionsWithPoll.storyLimit = 3;
